'use client'

import { type HTMLMotionProps, motion } from 'motion/react'
import type React from 'react'
import { Box, type BoxProps } from '../Layout'

/**
 * `MotionBox` composes the `Box` component with **framer-motion** `motion` component, this will allow us to add animation to our components in a declarative manner.
 */
type MotionBoxProps = HTMLMotionProps<'div'> & Omit<BoxProps, 'transition'>

const MotionBox = motion.create(Box) as React.ForwardRefExoticComponent<
    MotionBoxProps & React.RefAttributes<HTMLDivElement>
>

export { type MotionBoxProps, MotionBox }
